import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { AppState } from '@store/slices/generic.slice'

import {
  changePlaylistDefaultVoice,
  getPlaylistForTime,
} from '@store/thunk/playlist.thunk'
import {
  PlaylistAdapterExport,
  PlaylistModel,
} from '@store/slices/playlist.slice'

export const playlistExtraReducers = (
  builder: ActionReducerMapBuilder<AppState<PlaylistModel>>
) => {
  builder
    .addCase(getPlaylistForTime.pending, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(getPlaylistForTime.fulfilled, (state, action) => {
      PlaylistAdapterExport.upsertOne(state, action.payload)
      state.loading = false
    })
    .addCase(getPlaylistForTime.rejected, (state, action) => {
      state.loading = false
      state.error = `Stažení playlistu ${action.meta.arg.fromTime.toString()} se nepovedlo`
    })
    .addCase(changePlaylistDefaultVoice.pending, (state, action) => {
      state.inProgress = [action.meta.arg.playlistId, ...state.inProgress]
      state.error = null
    })
    .addCase(changePlaylistDefaultVoice.fulfilled, (state, action) => {
      state.inProgress = state.inProgress.filter(
        (id) => id !== action.meta.arg.playlistId
      )
      PlaylistAdapterExport.upsertOne(state, action.payload)
      state.loading = false
    })
    .addCase(changePlaylistDefaultVoice.rejected, (state, action) => {
      state.inProgress = state.inProgress.filter(
        (id) => id !== action.meta.arg.playlistId
      )
      state.error = `Aktualizace hlasu pro playlist ${action.meta.arg.playlistId} se nepovedlo`
    })
}
